import { Box } from 'components/Box';
import { Tag } from 'components/Tag';
import { Accordion } from 'features/ContactSidebar/Accordion';
import { ContactSidebarContext } from 'features/ContactSidebar/ContactSidebarContext';
import map from 'lodash/map';
import { useContext } from 'react';

export const ContactSidebarMainAvailability = () => {
  const { userProfile, hasPreferences } = useContext(ContactSidebarContext);

  const hasAnyInformation =
    hasPreferences?.startDate || hasPreferences?.schedule || hasPreferences?.desiredRoles;

  if (!hasAnyInformation) {
    return null;
  }

  const startDate = userProfile.startDate();
  const schedule = userProfile.schedule();
  const desiredRoles = userProfile.desiredRoles();

  return (
    <Accordion title="Availability">
      <Box>
        <div className="flex flex-col gap-3 py-1">
          {(desiredRoles?.length || null) && (
            <div className="space-y-1.5">
              <p className="text-primary-pure-blue">Job Type:</p>
              <div className="flex flex-wrap items-start justify-start gap-2">
                {desiredRoles.map((value) => (
                  <Tag key={value}>{value}</Tag>
                ))}
              </div>
            </div>
          )}

          {Boolean(startDate) && (
            <div className="space-y-0.5">
              <p className="text-primary-pure-blue">Start Date:</p>
              <p>{startDate}</p>
            </div>
          )}

          {((schedule && Object.keys(schedule).length) || null) && (
            <div className="space-y-2">
              <p className="text-primary-pure-blue">Work Days:</p>
              <dl className="flex flex-col gap-1.5">
                {map(
                  schedule,
                  (
                    hours: {
                      startTime: string;
                      endTime: string;
                    }[],
                    day: string,
                  ) => {
                    if (!hours.length) return null;

                    return (
                      <div key={day} className="flex justify-start items-start gap-2.5">
                        <dt>
                          <Tag className="!w-[42px] !justify-center" variant="warning">
                            {day.slice(0, 3)}
                          </Tag>
                        </dt>
                        <dd>
                          <ul className="space-y-0.5 text-neutral-darker pt-[3px]">
                            {hours.map((time) => (
                              <li key={`${day}-${time.startTime}-${time.endTime}`}>
                                {time.startTime} to {time.endTime}
                              </li>
                            ))}
                          </ul>
                        </dd>
                      </div>
                    );
                  },
                )}
              </dl>
            </div>
          )}
        </div>
      </Box>
    </Accordion>
  );
};

ContactSidebarMainAvailability.displayName = 'ContactSidebarMainAvailability';
